export default {
   'all': {
        'zh':'全选',
        'en':'All'
   }
}


// WEBPACK FOOTER //
// ./src/Locale/n3Select.js